import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;


export const HeaderContainer = styled.div`
    display: flex;
    margin: 40px auto;
    margin-top: 10px;
    max-width: 900px;
    align-items: center;
    
    @media (max-width: 1000px) { 
        padding: 0 70px;
        margin-bottom: 0;
    }

    @media (max-width: 815px) { 
        
        padding: 0 70px;
        margin-bottom: 0;
    }
    
    @media (max-width: 700px) { 
        
        padding: 0 70px;
        padding-top: 25px;
        margin-bottom: 0;
    }
    
    @media (max-width: 400px) { 
        padding: 25px;
        margin-bottom: 0;
    }
`;

export const HeaderTitle = styled.h1`
  color: #e0e0e0;
  font-size: 26px;
  
  @media (max-width: 815px) {
    display: inline;
  }
  @media (max-width: 400px) {
    font-size: 17px;
  }
`;

export const HeaderNumber = styled.h1`
  font-size: 22px;
  font-weight: normal;
  margin-right: 10px;
  color: #BB86FC;

  @media (max-width: 815px) {
    display: inline;
  }
  @media (max-width: 400px) {
    font-size: 15px;
  }
`;

export const Container = styled.div`
  max-width: 900px;
  margin: 40px auto;
  font-size: 17px;
  
  @media (max-width: 1000px) { 
      padding: 0 70px;
  }
  
  @media (max-width: 815px) { 
      display: block;
      margin-top: 20px;
  }
  
  @media (max-width: 700px) { 
      display: block;
      margin-top: 20px;
  }
  
  @media (max-width: 400px) {
      margin-top: 0px; 
      padding: 0px 25px;
  }
`;

export const JobSection = styled.div`
  display: grid;
  grid-template-columns: minmax(140px, 200px) 1fr;
  gap: 1rem;
  margin-bottom: 50px;
  animation: ${fadeIn} 0.5s cubic-bezier(0.645, 0.045, 0.355, 1);

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 0.5rem;
    margin-bottom: 40px;
  }
`;

export const Duration = styled.div`
  font-family: monospace;
  font-size: 13px;
  color: #8892b0;
`;

export const JobDetails = styled.div`
  position: relative;
`;

export const Company = styled.h3`
  font-size: 18px;
  font-weight: 500;
  color: #e6e6e6;
  margin-bottom: 10px;
`;

export const Description = styled.p`
  color: #8892b0;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 20px;
`;

export const TechList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 0;
  margin: 10px 0 0 0;
  list-style: none;
`;

export const TechItem = styled.li`
  color: #BB86FC;
  font-family: monospace;
  font-size: 13px;
  padding: 3px 8px;
  background: rgba(187, 134, 252, 0.1);
  border-radius: 3px;
  transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

  &:hover {
    background: rgba(187, 134, 252, 0.2);
    transform: translateY(-2px);
  }
`; 